import styled from 'styled-components';

export const BellWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BellButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 4rem;
  min-width: 5rem;
  padding: 0 1rem;
  border: none;
  border-radius: 0 0 10px 10px;
  background-color: ${({ theme }) => theme.colors?.secondary};
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.9;
  }

  .MuiSvgIcon-root {
    color: ${({ theme }) => theme.colors?.text?.tertiary};
  }
`;

export const PopoverPaper = styled.div`
  max-width: 380px;
  min-width: 320px;
  max-height: 420px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors?.backgroundColor};
  border-radius: 8px;
`;

export const PopoverHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors?.gray03};
`;

export const PopoverTitle = styled.div`
  font-weight: 600;
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
  color: ${({ theme }) => theme.colors?.text?.primary ?? theme.colors?.gray01};
`;

export const MarkAllButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};
  color: ${({ theme }) => theme.colors?.primary};
  font-weight: 600;
`;

export const List = styled.div`
  overflow-y: auto;
  max-height: 400px;
`;

export const Item = styled.div<{ $unread?: boolean }>`
  padding: 0.875rem 1.25rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors?.gray03};
  cursor: pointer;
  background-color: ${({ theme, $unread }) =>
    $unread ? theme.colors?.gray01 : theme.colors?.backgroundColor};
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors?.gray02};
  }
`;

export const ItemTitle = styled.div`
  font-weight: 600;
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};
  margin-bottom: 0.25rem;
  color: ${({ theme }) => theme.colors?.text?.primary ?? theme.colors?.gray01};
`;

export const ItemMessage = styled.div`
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};
  line-height: 1.35;
  color: ${({ theme }) => theme.colors?.text?.secondary ?? theme.colors?.gray02};
`;

export const ItemDate = styled.div`
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs10};
  margin-top: 0.35rem;
  color: ${({ theme }) => theme.colors?.text?.secondary ?? theme.colors?.gray02};
`;

export const EmptyMessage = styled.div`
  padding: 2rem 1.25rem;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};
  color: ${({ theme }) => theme.colors?.text?.secondary ?? theme.colors?.gray02};
`;
